












































import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator'
import { Pipeline } from '@/api/model/pipeline'
import { Source } from '@/api/model/source'
import { InputSelectOption } from '@/helpers/options'
import { cloneDeep, isEqual } from 'lodash'
import { SourceAPI } from '@/api/backend-client'
import { usePipelineConnections } from '@/composables/usePipelineConnections'
import { ReferralChannel } from '@/api/types'
import { TriggeredReferral } from '@/api/model/triggered-referral'
const pipelineConnections = usePipelineConnections(false)

@Component
export default class CreateAutoLeadFormStep2 extends Vue {
    @Prop({ required: true }) readonly value!: TriggeredReferral
    editingValue: TriggeredReferral = null
    pipelines: Pipeline[] = []
    sources: Source[] = []
    loading: boolean = false
    @Inject() kenmerkLabel: (kenmerkId) => string

    @Watch('value', {immediate: true})
    onValueChanged() {
        this.editingValue = cloneDeep(this.value)
    }

    @Watch('editingValue.referralPipeline')
    @Watch('editingValue.referralNewSource')
    onEditingValueChanged() {
        if (isEqual(this.editingValue, this.value)) {
            return
        }

        this.$emit('update:value', this.editingValue)
    }

    @Watch('editingValue.referralPipeline', {immediate: true})
    async updateSources(): Promise<void> {
        if (!this.editingValue.referralPipeline) {
            this.sources = []
            return
        }

        this.sources = await SourceAPI.getAll({
            company: this.editingValue.referralPipeline.company.id,
            channel: ReferralChannel.REALWORKS,
            active: 1,
        })
    }

    async created() {
        await this.loadContent()
    }

    async loadContent(): Promise<void> {
        this.loading = true
        await pipelineConnections.loadPipelineConnections()
        this.pipelines = pipelineConnections.buildOutgoingPipelines({ includeOwn: true})
        this.loading = false
    }

    get availablePipelines(): Pipeline[] {
        return this.pipelines
            .filter(pipeline => pipeline.active)
            .sort((a, b) => a.name.localeCompare(b.name))
    }

    get externalPipelineSelected(): boolean {
        return this.editingValue.referralPipeline && this.editingValue.referralPipeline.company.id !== this.$currentCompany.id
    }

    get validSources(): InputSelectOption[] {
        return this.sources.map(source => ({
            label: source.name,
            subtext: this.$t(`channel.${source.channel}`).toString(),
            value: source.id,
        }))
    }

    get referralNewSource(): string|null {
        return this.editingValue.referralNewSource?.id
    }

    set referralNewSource(id: string|null) {
        this.editingValue.referralNewSource = this.$currentCompany.activeSources.find(source => source.id === id)
    }

    get triggerType(): string {
        if (this.value.triggerType === 'agendaTypes') {
            return 'afspraak'
        } else if (this.value.triggerType === 'taakTypes') {
            return 'taak'
        } else if (this.value.triggerType === 'relatieTypes') {
            return 'relatie'
        } else {
            return 'kenmerk'
        }
    }

    get assignArea(): string {
        return this.value.realworksCredentials.description
    }

    get assignType() {
        if (this.value.triggerType === 'agendaTypes') {
            return this.value.agendaTypes.join(', ')
        } else if (this.value.triggerType === 'taakTypes') {
            return this.value.taakTypes.join(', ')
        } else if (this.value.triggerType === 'relatieTypes') {
            return this.value.relatieTypes.join(', ')
        } else {
            return this.kenmerkLabel(this.value.realworksKenmerkId)
        }
    }
}
